/** The frontend's one home for src/lib/contract-particulars.ts `agreedOnHapMetrix`; quick add records one made outside. */
export function agreedOnHapMetrix(signingMethod: string | null | undefined): boolean {
  return signingMethod !== 'offline_attested';
}

/** Mirrors src/lib/contract-particulars.ts `AGREEMENT_COPY_MIME_TYPES`; the server refuses any other. */
export const AGREEMENT_COPY_MIME_TYPES: readonly string[] = ['application/pdf', 'image/png', 'image/jpeg'];
export const AGREEMENT_COPY_ACCEPT = AGREEMENT_COPY_MIME_TYPES.join(',');
